import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Ng2StateDeclaration, UIRouterModule } from '@uirouter/angular';
import { DashboardPageComponent } from './dashboard-page.component';
import { RequisitionsModule } from 'src/app/features/requisitions/requisitions.module';

const states: Ng2StateDeclaration[] = [
  {
    name: 'missioncontrol.dashboard',
    url: '/dashboard',
    component: DashboardPageComponent,
    data: {
      requireLogin: true
    },
    params: {
      loginParamsObject: null
    }
  }
];

@NgModule({
  declarations: [DashboardPageComponent],
  imports: [
    CommonModule,
    RequisitionsModule,
    UIRouterModule.forChild({ states })
  ],
  exports: [],
  entryComponents: [DashboardPageComponent]
})

export class DashboardPageModule { }